import { render, staticRenderFns } from "./AgregarFactura.vue?vue&type=template&id=c274bb6c"
import script from "./AgregarFactura.vue?vue&type=script&lang=js"
export * from "./AgregarFactura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports